import { render, staticRenderFns } from "./wechantform.vue?vue&type=template&id=84d5c736&scoped=true"
import script from "./wechantform.vue?vue&type=script&lang=js"
export * from "./wechantform.vue?vue&type=script&lang=js"
import style0 from "./wechantform.vue?vue&type=style&index=0&id=84d5c736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d5c736",
  null
  
)

export default component.exports